import axios from 'axios'
import config from './config'
var firebase = window.firebase

/**
 * Add promo code to an account
 * @param {string} promo valid promo code
 * @returns {promise}
 */
function addPromo (accountId, promo) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(function (token) {
      return axios
        .post(`${config.API_BASE_URL}/admin/promo`, {
          authToken: token,
          accountId: accountId,
          promo: promo
        })
    })
}

/**
 * Retrieve a pixel configuration
 * @param {string} pixelId
 */
function getPixel (pixelId) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(authToken => {
      return axios
        .get(`${config.API_BASE_URL}/admin/pixel`, {
          params: {
            pixelId,
            authToken
          }
        })
        .then(res => {
          return res.data
        })
    })
}

/**
 * Update a pixel configuration
 * @param {string} pixelId
 * @param {object} data
 */
function updatePixel (pixelId, data) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(authToken => {
      return axios
        .patch(`${config.API_BASE_URL}/admin/pixel`, {
          pixelId,
          authToken,
          config: data
        })
    })
}

export default {
  addPromo,
  getPixel,
  updatePixel
}



// WEBPACK FOOTER //
// ./src/api/account.js